import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/app/apps/royalur/src/app/(auth)/recover/ForgotPasswordForm.tsx");
